import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 7 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.6 13.4H.532a.535.535 0 0 1-.413-.872L4.644 7 .12 1.47A.534.534 0 0 1 .533.6h1.066a.53.53 0 0 1 .413.196l4.8 5.866a.534.534 0 0 1 0 .676l-4.8 5.867a.54.54 0 0 1-.413.195" }, null, -1)
  ])))
}
export default { render: render }